<section class="comment-section">
  <p class="font-sm sparro-grey-900">
    This place is for discussion regarding competition only. For any other queries, please write to
    us at contact@uni.xyz. Any private information shared here is the sole discretion of author and
    is not protected under
    <a href="https://uni.xyz/policy/general-terms/privacy" target="_blank">UNI Privacy Policy</a>
  </p>
  <p class="font-sm font-bold sparro-orange-600">Discussions</p>

  <uni-comment-group
    [slug]="compSlug"
    [source]="source"
    [user]="user"
    [nested]="true"
    [max_nest_depth]="2">
  </uni-comment-group>
</section>
